export const filterContainerStyles = {
    flexDirection: 'column',
    gap: '16px',
    padding: '24px 0',
    backgroundColor: '#fff',
    borderRadius: '12px'
};

export const filtersRowStyles = {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    '@media (max-width: 768px)': {
        flexDirection: 'column',
        gap: '16px'
    }
};

export const filtersGroupStyles = {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
    alignItems: 'center',
    '@media (max-width: 768px)': {
        width: '100%'
    }
};

export const selectStyles = {
    width: '220px', 
    margin: 0,
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        '&:hover': {
            '& fieldset': {
                borderColor: '#6366F1'
            }
        },
        '& fieldset': {
            borderColor: '#E4E6EF',
            borderWidth: '1.5px'
        }
    },
    '& .MuiInputLabel-root': {
        color: '#2B3674',
        fontSize: '14px',
        fontWeight: 500
    },
    '& .MuiSelect-select': {
        padding: '12px 14px'
    }
};
